<template>
  <form-dialog :value="value" @input="close($event)" :title="dialogTitle" :can-save="canSave">
    <response-details v-model="showResponse"
                      @close="closeResponseDialog"
                      @download="downloadContent"
                      @direct-download="downloadDirectContent"
                      :endpoint="endpoint"
                      :endpoint-data="endpointData"
    />

      <v-container>
        <v-radio-group
            v-if="!isDirectEndpoint"
            v-model="viewOption"
            label="Anzeigeart wählen"
            column
        >
          <v-radio
              label="Datum Parameter eingeben"
              color="primary"
              value="date"
          ></v-radio>
          <v-radio
              label="Aktuellste Aufzeichnungen anzeigen"
              color="primary"
              value="timeline"
          ></v-radio>
        </v-radio-group>
      <v-card v-if="timelineActive && !isDirectEndpoint" color="#F5F5F5" elevation="0" style="width: 100%;">
        <v-data-table
            :headers="headers"
            :items="timelineTreeItems"
            :items-per-page="7"
            :loading="loadingData"
            :footer-props="footerProps"
            class="elevation-1"
            mobile-breakpoint="0"
        >
          <template v-slot:item="row">
            <tr>
              <td class="text-left">
                {{ formattedDateTime(row.item.created_at) }}
              </td>
              <td class="text-left">
                {{ row.item.content_encoding }}
              </td>
              <td class="text-right">
                <v-icon
                color="primary"
                @click="downloadContent(row.item)">
                  mdi-download
                </v-icon>
                <v-icon
                color="primary"
                @click="showResponseDialog(row.item)">
                  mdi-eye
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <v-card v-else>
        <v-form
          ref="lottoDataForm"
          v-model="validForm"
          @submit="getRelevantEndpointData">
        <v-card-text  class="text-left" v-if="!isDirectEndpoint">
          Wenn Sie kein Datum eingeben, werden die neuesten gespeicherten Daten angezeigt.
          <v-text-field
              :label="dateFormatLabel"
              v-model="date"
              :rules="dateRules"
          ></v-text-field>
        </v-card-text>
        <v-card-text class="text-left" v-else>
          Geben Sie die mit Komma getrennten Query-Parameters ein, die bei der direkten Abfrage übergeben werden sollen
          <v-text-field
              label="Query Parameter"
              placeholder="a=1, b=2"
              v-model="queryParams"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
              depressed
              color="primary"
              @click="this.getRelevantEndpointData"
          >
            Daten abfragen
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-left" v-if="STAEPPCloudIsPresent">
            Die STÄPP Cloud API-Dokumentation dient zur Bestimmung der benötigten Query-Parameters der Endpunkte.
            <a href="https://staepp-cloud.de/doc/" target="_blank">STÄPP CLOUD API-Dokumentation</a>
        </v-card-text>
        </v-form>
      </v-card>
        <v-row
            align="center"
        >
          <v-col
              md="6"
              offset-md="3"
          >
            <v-progress-circular
                :size="50"
                :width="7"
                v-if="loadingData"
                color="red"
                indeterminate
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>

  </form-dialog>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
import FormDialog from '../components/FormDialog'
import endpointApi from '../api/endpoints'
import ErrorStore from "@/stores/ErrorStore";
import vkbeautify from 'vkbeautify';
import moment from 'moment';
import ResponseDetails from "@/components/ResponseDetails";
import config from "@/config";
import timeformatter from "@/utils/timeformatter"
export default {
  name: 'endpoint-details',
  components: { FormDialog, ResponseDetails },
  data () {
    return {
      viewOption: 'timeline',
      timelineTreeItems: [],
      endpointData: null,
      withDate: false,
      loadingData: false,
      queryParams: null,
      date: null,
      canSave: false,
      dateFormatView: 'dd-mm-yyyy hh:mm',
      dateRules: [
        v => {
          if(v) {
            return (moment(v, "DD-MM-YYYY HH:mm", true).isValid() ||
                moment(v, "DD-MM-YYYY HH:mm:ss", true).isValid())
            || `Das Datum-Format stimmt nicht. Format: ${this.dateFormatView}. Sekundeneingabe ist optional.`
          }
          return true
        }
        ],
      headers: [
        { text: 'Datum', value: 'created_at', align: 'left' },
        { text: 'Kodierung', value: 'content_encoding', align: 'left' },
        { text: 'Optionen', value: '', align: 'right' }
      ],
      footerProps: {'items-per-page-options': [10, 20, 40, 80, 100, 200]},
      showResponse: false,
      validForm: true
    }
  },
  props: {
    value: Boolean,
    endpoint: Object
  },
  computed: {
    STAEPPCloudIsPresent() {
      return this.endpoint && this.endpoint.product && this.endpoint.product.name &&
          this.endpoint.product.name.toLowerCase().indexOf('stäpp cloud') !== -1
    },
    dateFormatLabel() {
      return `Datumformat ${this.dateFormatView}`
    },
    timelineActive () {
      return this.viewOption === 'timeline'
    },
    dialogTitle () {
      return this.endpoint ? `${this.endpoint.name} | ${this.endpoint.endpoint_flavor.name}`: ''
    },
    isDirectEndpoint () {
      return this.endpoint && this.endpoint.direct
    },
    prettyPrinted () {
        if (this.endpoint && this.endpoint.expected_format && this.endpointData) {
          switch (this.endpoint.expected_format) {
            case 'xml':
              try {
                return vkbeautify.xml(this.isDirectEndpoint ? this.endpointData : this.endpointData.response)
              }
              catch (e) {
                return this.isDirectEndpoint? this.endpointData : this.endpointData.response
              }
            case 'json':
              try {
                return vkbeautify.json(this.isDirectEndpoint ? this.endpointData : this.endpointData.response)
              }
              catch (e) {
                return this.isDirectEndpoint? this.endpointData : this.endpointData.response
              }
              default:
              return this.isDirectEndpoint? this.endpointData : this.endpointData.response
          }
        }
      return ''
    }
  },
  mounted () {
    if(this.isDirectEndpoint){
      this.viewOption = 'date'
    } else {
      this.onChangeItemsCount(1000)
    }
  },
  methods: {
    onChangeItemsCount (count) {
      this.loadingData = true
      if (this.endpoint) {
        const requestParams = {}
        this.timelineTreeItems = []
        requestParams['limit'] = count
        endpointApi.getTimelineTree(this.endpoint.id, requestParams).then(r=> {
          this.timelineTreeItems = r.data
          this.loadingData = false
        }).catch(e=>{
          this.loadingData = false
        })
      }
    },
    showResponseDialog (item) {
      this.endpointData = item
      this.showResponse = true
    },
    closeResponseDialog () {
      this.showResponse = false
    },
    getRelevantEndpointData () {
      if(this.$refs.lottoDataForm.validate()) {
        if (this.isDirectEndpoint) {
          this.getDirectEndpointData()
        } else {
          this.getEndpointData()
        }
      }
    },
    getEndpointData () {
      this.loadingData = true
      this.endpointData = null
      if (this.endpoint) {
        const requestParams = {}
        if (! [null, undefined].includes(this.date)) {
          requestParams['date'] = this.date
        }
        endpointApi.getEndpointData(this.endpoint.id, requestParams).then(r => {
          this.loadingData = false
          this.showResponseDialog(r.data)
        }).catch(error => {
          this.loadingData = false
         if (error.response && error.response.data) {
           ErrorStore.showError(error.response.data)
         }
        })
      }
    },
    getDirectEndpointData () {
      this.loadingData = true
      this.endpointData = null
      if (this.endpoint) {
        const params = this.queryParams ? { 'query_parameters': this.queryParams } : {}
        endpointApi.getDirectEndpointDataByteStreamResponse(this.endpoint.id, params).then(r => {
          this.loadingData = false
          this.showResponseDialog(r.data)
        }).catch(error => {
          this.loadingData = false
          if (error.response && error.response.data) {
            ErrorStore.showError(error.response.data)
          }
        })
      }
    },
    close() {
      this.$emit('close')
    },
    downloadContent (item) {
      const link = document.createElement("a");
      link.download = name;
      const productIdentifier = this.endpoint ? this.endpoint.product.identifier : -1
      const endpointId = this.endpoint ? this.endpoint.id : -1
      const dataId = item ? item.id : -1
      link.href = `${config.apiUrl}product/${productIdentifier}/endpoints/${endpointId}/data/${dataId}/file`
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadDirectContent() {
      const link = document.createElement("a");
      link.download = name;
      link.href = `${config.apiUrl}product/${this.endpoint.product.identifier}/direct_endpoints/${this.endpoint.id}/file?query_parameters=${this.queryParams}`
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formattedDateTime(date) {
      return timeformatter.format(date)
    }

  },
  watch: {
    viewOption() {
      this.endpointData=null
      if(this.timelineActive) {
        this.onChangeItemsCount(1000)
      }
    }
  }
}
</script>
<style>
pre {
  text-align: justify;
}
</style>